import React from 'react';
import { ArrowLeft, Search, X } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';

export function NewConversation({
  userRole, allUsers, searchUser, setSearchUser,
  newConvType, setNewConvType, newGroupName, setNewGroupName,
  newGroupMembers, onToggleMember, onStartDM, onCreateGroup, onBack,
}) {
  const filteredUsers = allUsers.filter(u =>
    u.name.toLowerCase().includes(searchUser.toLowerCase())
  );

  return (
    <>
      <div className="px-3 py-2.5 border-b border-slate-100 flex items-center gap-2 bg-gradient-to-r from-blue-600 to-indigo-600">
        <Button variant="ghost" size="sm" onClick={onBack} className="text-white hover:bg-white/20 h-7 w-7 p-0">
          <ArrowLeft size={16} />
        </Button>
        <p className="text-sm font-bold text-white">New Conversation</p>
      </div>
      <div className="px-3 pt-3">
        <div className="flex gap-1 bg-slate-100 rounded-lg p-0.5 mb-3">
          {['dm', 'group', ...(userRole === 'admin' ? ['broadcast'] : [])].map(t => (
            <button
              key={t}
              data-testid={`new-conv-type-${t}`}
              onClick={() => { setNewConvType(t); }}
              className={`flex-1 text-xs font-semibold py-1.5 rounded-md transition-all ${newConvType === t ? 'bg-white text-blue-900 shadow-sm' : 'text-slate-500'}`}
            >
              {t === 'dm' ? 'Direct' : t === 'group' ? 'Group' : 'Broadcast'}
            </button>
          ))}
        </div>

        {newConvType !== 'dm' && (
          <Input
            data-testid="new-conv-name"
            value={newGroupName}
            onChange={e => setNewGroupName(e.target.value)}
            placeholder={newConvType === 'broadcast' ? 'Broadcast channel name' : 'Group name'}
            className="h-8 text-xs rounded-lg mb-2 border-slate-200"
          />
        )}

        <div className="relative mb-2">
          <Search size={14} className="absolute left-2.5 top-2 text-slate-400" />
          <Input
            data-testid="search-chat-users"
            value={searchUser}
            onChange={e => setSearchUser(e.target.value)}
            placeholder="Search users..."
            className="h-8 text-xs rounded-lg pl-8 border-slate-200"
          />
        </div>
      </div>

      <div className="flex-1 overflow-y-auto px-3">
        {filteredUsers.map(u => (
          <button
            key={u.id}
            data-testid={`chat-user-${u.id}`}
            onClick={() => {
              if (newConvType === 'dm') { onStartDM(u.id); }
              else { onToggleMember(u.id); }
            }}
            className={`w-full flex items-center gap-2.5 px-2 py-2 rounded-lg text-left transition-colors ${
              newConvType !== 'dm' && newGroupMembers.includes(u.id) ? 'bg-blue-50 border border-blue-200' : 'hover:bg-slate-50'
            }`}
          >
            <div className="w-8 h-8 rounded-full bg-blue-100 flex items-center justify-center text-blue-700 font-bold text-xs">{u.name?.charAt(0)}</div>
            <div className="flex-1">
              <p className="text-sm font-semibold text-blue-900">{u.name}</p>
              <p className="text-[10px] text-slate-400 uppercase">{u.role?.replace('_', ' ')}</p>
            </div>
            {newConvType !== 'dm' && newGroupMembers.includes(u.id) && (
              <span className="w-5 h-5 bg-blue-600 rounded-full flex items-center justify-center"><X size={10} className="text-white" /></span>
            )}
          </button>
        ))}
      </div>

      {newConvType !== 'dm' && (
        <div className="px-3 py-2 border-t border-slate-100">
          <Button data-testid="create-conv-btn" onClick={onCreateGroup} className="w-full bg-blue-600 hover:bg-blue-700 text-white rounded-lg h-9 text-xs font-bold">
            Create {newConvType === 'broadcast' ? 'Broadcast' : 'Group'} ({newGroupMembers.length} members)
          </Button>
        </div>
      )}
    </>
  );
}
